var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSeats4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.791 13.449H9.979l2.644-4.241.168-.289v4.53z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.5a7.5 7.5 0 010 15H9a7.5 7.5 0 010-15h6zm-2.26 2.086l-4.6 7.207.059 1.062h4.592v2.395h1.765v-2.395h1.333v-1.406h-1.333V6.586H12.74z",
    fill: "currentColor"
  })));
}
SvgPokerSeats4.displayName = 'PokerSeats4';
export default SvgPokerSeats4;